<template>
    <div class="wtw-container outfit-type-container clearfix">
        <div class="outfit-type-option"
             v-for="option in options"
             @click.stop="toggleOption(option.product_option_value_id)"
             :class="{active: optionActive(option.product_option_value_id) || allActive}"
        >
            <div class="image-wrapper">
                <img :src="option.product_option_value_image_url" />
            </div>
            <img :src="imageUrl('Check-2-white.svg')" class="outfit-check" v-show="optionActive(option.product_option_value_id) || allActive">
            <p class="option"
                 :class="{active: optionActive(option.product_option_value_id)}"
            >
                {{ option.product_option_value_title }}
            </p>
        </div>
    </div>
</template>

<script>
    import Mixins from '../../../mixins/mixins';

    export default{
        data() {
            return {
                optionValues: [],
                allActive: false,
                canGoToNextStep: true
            }
        },
        mixins: [Mixins],
        props: ['options', 'sendOptions', 'optionsAll', 'optionsSelected'],
        created(){
            if(this.optionsSelected) {
                this.optionValues = this.optionsSelected;
            }
        },
        methods: {
            toggleOption(optionValue){
                let index = this.optionIndex(optionValue);
                if (index !== -1) {
                    this.optionValues.splice(index, 1);
                } else {
                    this.optionValues.push(optionValue);
                }

                !this.anyOptionsActive ?  this.allActive = true : this.allActive = false;
            },
            optionIndex(optionValue){
                return this.optionValues.indexOf(optionValue);
            },
            optionActive(optionValue){
                return this.optionIndex(optionValue) !== -1;
            }
        },
        computed: {
            anyOptionsActive(){
               return this.optionValues.length;
            }
        },
        watch: {
            sendOptions: function () {
                if (this.sendOptions) {
                    let optionIds = this.options.map((option) => {
                        return option.product_option_value_id;
                    });
                    if(this.$parent.getNoSkip) {
                        let found = optionIds.some(r=> this.optionValues.indexOf(r) >= 0)
                        this.canGoToNextStep = found ? true : false
                    } else {
                        this.canGoToNextStep = true
                    }
                    // prevent duplicates in selected array
                    this.$parent.$emit('removeOptions', optionIds)
                    this.$parent.$emit('optionsSending', this.optionValues, this.canGoToNextStep)
                }
            }
        },
        mounted(){
            if(!this.optionsSelected || (this.optionsSelected && !this.optionsSelected.length)) {
                this.allActive = true;
            }
        },
    }
</script>